export default __webpack_public_path__ + "static/media/fibremax.49dc1be5.png";